import type { ReactNode } from "react";
import { desktopBridge } from "../../lib/desktop";
import { WindowChrome } from "../WindowChrome";

/** The Nexamero mark, two people forming an "N", from the brand mark in @rakazo/ui-tokens/assets. */
function NexameroMark() {
  return (
    <span
      aria-hidden="true"
      className="grid size-8 shrink-0 place-items-center rounded-[10px] bg-primary text-primary-foreground shadow-panel"
    >
      <svg viewBox="0 0 391 359" className="size-5" fill="currentColor">
        <path d="M29.3 354C19.2 353.1 13.2 349.9 9 343.3C3.8 335.1 3.7 333.6 4.3 254C4.8 171.3 4.8 172.3 12.3 157.5C17.8 146.7 28.5 136 39.5 130.3C52.1 123.8 57.5 122.7 81.5 122.1L102.5 121.5L97 117.9C79.7 106.7 70.4 83.2 75.5 63.7C81.6 40.3 101.8 25 126.5 25C141.2 25 152.2 29.4 163.1 39.7C171.4 47.6 176.4 56.8 178.2 67.7C182.6 94 164.1 120.2 137 126L129.6 127.6L134.3 129.9C136.9 131.2 142.3 134.4 146.3 137C153.5 141.8 155.2 143.2 178.1 163.4C184.9 169.5 197.9 180.9 207 188.9C216 196.9 226.4 206.2 230 209.5C249.2 226.9 272.6 246.8 276.3 248.8C284.7 253.5 294.2 249.9 296.9 241.1C300.5 229.1 296.2 222.8 268.7 200C256.4 189.7 251.2 185.3 236.2 172.2C224.7 162.1 221.8 159.1 220.4 155.4C217.7 148.2 219.3 144.8 230.3 134.2C254.9 110.5 263.4 103.7 275.3 98.7C282.8 95.6 293.4 93 299.2 93C303.7 93 304.1 91.6 300.1 90.2C295.3 88.5 287.4 82.2 283.1 76.7C272.3 62.6 270.4 45.2 278 29.2C283.1 18.3 293.4 9.6 305.4 5.8C313.6 3.2 328.9 3.7 337.1 7C344.1 9.7 352.9 16.6 357.5 22.8C367.4 36.2 368.6 56.7 360.5 70.7C356.7 77.1 349.2 84.6 342.6 88.4C337.5 91.5 337 92 339.1 92.4C349.8 94.6 353.3 95.7 358.8 98.3C371.3 104.3 381.1 116.2 384.6 129.4C386.4 136.1 386.7 306.7 384.9 315.2C382.2 328 372 341.6 360.5 347.7C350.4 353 344.6 354.1 322.4 354.7C291.7 355.6 275.3 352.9 259 344.4C249.2 339.3 245.3 336.2 212 307.5C184.9 284.2 167.8 269.5 155 258.8C150.3 254.8 143.1 248.6 139 244.9C127.5 234.7 124.6 233 118.6 233C112.6 233 107.8 235.5 105.5 239.9C103.6 243.6 103.5 252 105.4 256.3C106.7 259.4 118.1 270.4 138.4 288C143.8 292.6 148.8 297.7 149.6 299.2C150.4 300.7 151 304.3 151 307.2L151 312.5L139.4 323.8C124.6 338.2 117.9 343.2 107.5 348.1C95.1 353.8 86.3 355 59.6 354.9C47.5 354.8 33.8 354.4 29.3 354Z" />
      </svg>
    </span>
  );
}

/**
 * Spans the app above the floating sidebar, chat and side panel: mark and Space tabs at the
 * start, account controls at the end. The bar itself drags the desktop window.
 */
export function ShellTopBar({ spaceTabs, account }: { spaceTabs: ReactNode; account: ReactNode }) {
  return (
    <header
      data-testid="shell-top-bar"
      className="app-drag flex h-14 shrink-0 items-center gap-3 px-3"
    >
      {desktopBridge() ? <WindowChrome /> : null}
      <NexameroMark />
      <div className="app-no-drag flex min-w-0">{spaceTabs}</div>
      <div className="app-no-drag ms-auto flex shrink-0 items-center">{account}</div>
    </header>
  );
}
